import { Locale } from '@cars4ever/public-ui';

import IFieldConfig from '../types/IFieldConfig';

import { phoneMask } from './masksConfigMap';

const phoneNumberConfigMap: Record<Locale, IFieldConfig> = {
  [Locale.DK]: {
    inputProps: {
      shrinkLabel: true,
      customMaskConfig: {
        mask: (phoneMask || '') as string,
        lazy: false,
      },
    },
    validate: (value?: string): boolean => value?.length === 8,
  },
  [Locale.SE]: {
    inputProps: {
      type: 'tel',
    },
    validate: (value?: string): boolean => /^(\d|-| ){8,14}$/.test(value || ''),
  },
};

export default phoneNumberConfigMap;
